module.exports = __webpack_public_path__ + "img/SKLB-S1.17e58536.png";